import { State } from 'model/State';
import { Dispatch } from 'react';
import { injectGetCurrentPatientResponse } from './getCurrentPatient';
import { injectSummariserWriteToRecordResponse } from './summariserWriteToRecord';

export const toolbarIntegrationInit = (
  dispatch: Dispatch<unknown>,
  getState: () => State,
) => ({
  injectGetCurrentPatientResponse: injectGetCurrentPatientResponse(dispatch),
  injectSummariserWriteToRecordResponse: injectSummariserWriteToRecordResponse(dispatch, getState),
});
